/**
 * Seconds as the app prints them, two spellings over one clock.
 *
 * `clockDuration` is a clock reading: `m:ss`, or `h:mm:ss` past an hour, and `0` prints `0:00`. The
 * builder's rest cell, a clip's length, a pace per kilometre and a chart's gutter print time this way.
 *
 * `setDuration` is how a SET's time is written (canon view 19): `45 s` under two minutes, the clock
 * from two minutes on. Under two minutes a duration is a count of seconds; the athlete holds a plank
 * for sixty, not for one minute flat.
 */
export function clockDuration(seconds: number): string {
  const whole = Math.max(0, Math.round(seconds));
  const hours = Math.floor(whole / 3600);
  const minutes = Math.floor((whole % 3600) / 60);
  const rest = whole % 60;
  const pad = (value: number) => String(value).padStart(2, '0');
  return hours > 0 ? `${String(hours)}:${pad(minutes)}:${pad(rest)}` : `${String(minutes)}:${pad(rest)}`;
}

const SECONDS_WRITTEN_AS_A_COUNT = 120;

export function setDuration(seconds: number): string {
  const whole = Math.max(0, Math.round(seconds));
  return whole < SECONDS_WRITTEN_AS_A_COUNT ? `${String(whole)} s` : clockDuration(whole);
}
